import {
  ArrowRightOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { apiClient, ApiError } from "@nimbus-erp/api-client";
import { BrandMark } from "@nimbus-erp/ui";
import { useMutation,useQueryClient } from "@tanstack/react-query";
import { Alert, Button, Form, Input } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../store/authStore";

interface Values {
  username: string;
  password: string;
}

export function AdminLoginPage() {
  const navigate = useNavigate();
  const queryClient=useQueryClient();
  const { user, setSession } = useAdminAuth();
  useEffect(() => {
    if (user?.loginType === "PLATFORM") navigate("/tenants", { replace: true });
  }, [navigate, user]);
  const mutation = useMutation({
    mutationFn: (values: Values) =>
      apiClient.login({
        loginType: "PLATFORM",
        username: values.username.trim(),
        password: values.password,
      }),
    onSuccess: (session) => {
      queryClient.clear();
      queryClient.setQueryData(["platform-session"],session);
      setSession(session);
      navigate("/tenants", { replace: true });
    },
  });
  return (
    <main className="admin-login">
      <section className="admin-login__panel">
        <BrandMark inverse subtitle="SAAS CONSOLE" />
        <div className="admin-login__copy">
          <span>云猫 ERP · SaaS 管理中心</span>
          <h1>
            统一管理企业服务，
            <br />
            守住每一次授权边界。
          </h1>
          <p>集中处理企业开通、套餐、到期与额度，跨租户操作全程留痕。</p>
        </div>
        <div className="admin-login__signal">
          <i />
          <span>
            <strong>平台独立入口</strong>
            <small>企业账号与平台账号分开管理</small>
          </span>
          <em>受控访问</em>
        </div>
      </section>
      <section className="admin-login__form">
        <div className="admin-login__box fade-enter">
          <span className="console-label">云猫 ERP</span>
          <h2>平台管理登录</h2>
          <p>仅限授权的平台运营与实施人员。</p>
          {mutation.isError && (
            <Alert
              type="error"
              showIcon
              message={
                mutation.error instanceof ApiError
                  ? mutation.error.status === 401
                    ? "平台账号或密码不正确"
                    : mutation.error.message
                  : "登录失败"
              }
            />
          )}
          <Form<Values>
            layout="vertical"
            requiredMark={false}
            onFinish={(values) => mutation.mutate(values)}
            size="large"
          >
            <Form.Item
              label="平台账号"
              name="username"
              rules={[{ required: true, message: "请输入平台账号" }]}
            >
              <Input prefix={<UserOutlined />} autoComplete="username" />
            </Form.Item>
            <Form.Item
              label="登录密码"
              name="password"
              rules={[{ required: true, message: "请输入登录密码" }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                autoComplete="current-password"
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={mutation.isPending}
            >
              进入管理中心 <ArrowRightOutlined />
            </Button>
          </Form>
          <small className="admin-login__audit">
            所有平台跨租户操作必须填写原因并写入审计链路
          </small>
          <footer className="admin-login__registration">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
            >
              蜀ICP备2026022567号-2
            </a>
          </footer>
        </div>
      </section>
    </main>
  );
}
